import api from "./index";

export interface TermListParams {
  title?: string;
  order?: "ASC" | "DESC";
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: TermListParams, options?: any) => {
  return api.ProfessionalActivityTaxonomyApi.list(
    params.title,
    params.order,
    params.offset,
    params.limit,
    options
  );
};
